export const SERVER_ERRORS: {[key: number]: string} = {
  4003: 'WELCOME_PAGE_ERROR_MESSAGE_WRONG_CREDENTIALS',
  40033: 'WELCOME_PAGE_ERROR_MESSAGE_WRONG_CREDENTIALS',
};

export const SERVER_RESPONSE_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  MFA: 'MFA_CHALLENGE',
};

export const SERVER_ERRORS_DATA = {
  USER_LOCKED_CODE_NAME: 'USER_LOCKED',
  USER_LOCKED_CODE: 4026,
  USER_INCORRECT_STATE_CODE: 4012,
  MFA_TOO_MANY_RESEND_REQUEST_CODE_NAME: 'MFA_TOO_MANY_RESEND_REQUEST',
  MFA_TOO_MANY_RESEND_REQUEST_CODE: 40031,
  PASSWORD_RECOVERY_IN_PROGRESS_CODE_NAME: 'PASSWORD_RECOVERY_IN_PROGRESS',
  PASSWORD_RECOVERY_IN_PROGRESS_CODE: 4080,
  INVALID_LOGIN_COUNTRY_CODE_NAME: 'INVALID_LOGIN_COUNTRY',
  INVALID_LOGIN_COUNTRY_CODE: 40111,
  TOKEN_EXPIRED_CODE_NAME: 'JWT_TOKEN_EXPIRED',
  TOKEN_EXPIRED: 40043,
  INVALID_USER_NAME_OR_PASSWORD: 40033,
  AUTH_TOKEN_INVALID: 40040,
  INVALID_ANSWER: 40032,
  MFA_CODE_CAN_BE_USED_ONCE: 40082,
  AUTH_TOKEN_EXPIRED: 40042,
  BAD_LILI_TOKEN: 4079,
  WRONG_PASSWORD_FORMAT: 40015,
  PASSWORD_TOO_WEAK: 40027,
  PASSWORD_TOO_LONG: 40019,
};
